<template>
    <div class="expendDonation">
        <BasePage mode="list">
            <div slot="toolBar" class="toolBar">
                <el-button
                    v-access:add
                    icon="el-icon-plus"
                    size="small"
                    @click="add"
                    :disabled="isLoading"
                    >新增</el-button
                >
                <el-upload
                    v-access:add
                    class="upload-demo"
                    :action="action"
                    :headers="headers"
                    accept=".xlsx,.xls"
                    :before-upload="onCheckFile"
                    :data="{'expendType': 1}"
                    :on-success="onFileUpLoad"
                >
                    <el-button
                    v-access:add
                    icon="el-icon-upload"
                    size="small"
                    :disabled="isLoading"
                    >导入</el-button>
                </el-upload>

                <el-button
                    v-access:add
                    icon="el-icon-download"
                    size="small"
                    @click="exportData"
                    :disabled="isExport"
                    >导出</el-button
                >
                <el-button
                    v-access:add
                    icon="el-icon-download"
                    size="small"
                    @click="downloadTemplate"
                    :disabled="isLoading"
                    >模板</el-button
                >
                <el-button
                    v-access:modify
                    icon="el-icon-bell"
                    size="small"
                    @click="batchSet"
                    :disabled="isLoading"
                    >批量公示</el-button
                >
                <el-button
                    v-access:modify
                    icon="el-icon-delete"
                    size="small"
                    @click="batchDelete"
                    :disabled="isLoading"
                    >批量删除</el-button
                >
            </div>
            <div>
                <el-table
                    border
                    hightlight-current-row
                    style="width: 100%"
                    :header-cell-class-name="headerRow"
                    :data="list"
                    :max-height="tableMaxHeight()"
                    v-loading="isLoading"
                    @selection-change="onSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="ExpendTime"
                        label="支出时间"
                        width="160"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.ExpendTime*1000 | formatDate}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="Amount"
                        label="支出金额（元）"
                        width="150"
                        align="right"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.Amount | monetization2}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ProjectName"
                        label="接收方"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="Remark"
                        label="支出详情"
                        width="300"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="IsPublicity"
                        label="是否公示"
                        align="center"
                        width="100"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.IsPublicity?'是':'否' }}
                        </template>
                    </el-table-column>
                    <el-table-column 
                        label="操作"
                        width="200"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-button
                                v-access:modify
                                type="text"
                                size="mini"
                                @click="edit(scope.row)"
                            >编辑</el-button>
                            <el-button
                                v-access:delete
                                type="text"
                                size="mini"
                                @click="innerDel(scope.row)"
                            >删除</el-button>
                            <el-button
                                v-access:modify
                                type="text"
                                size="mini"
                                @click="settingStatus(scope.row)"
                            >{{ scope.row.IsPublicity?'取消公示':'公示' }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-wapper">
                <OfPagination
                    :total="total"
                    :pageSize="queryParam.pageSize"
                    :currentPage="queryParam.pageIndex"
                    @onSizeChange="handleSizeChange"
                    @onCurrentChange="handleCurrentChange"
                    :hideOnSinglePage="false"
                ></OfPagination>
            </div>
        </BasePage>
        <add-form ref="editForm" @onOk="callBack"></add-form>
    </div>
</template>
<script>
import api from "@/modules/zjrc/api";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import BasePage from "@/components/base/of_page/of_page";
import AddForm from '../addForm.vue'
import store from "@/store";
import { saveAs } from 'file-saver'
export default {
    components: {
        OfPagination,
        AddForm,
        BasePage
    },
    props: {
        queryParam: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            headerRow: "header-row",
            isLoading: false,
            list: [],
            total: 0,
            ids: [],
            action: "/api/expend/import",
            headers: {
                "OF-Authorization": store.getters.GetUserToken,
            },
            isExport: false
        }
    },
    methods: {
        batchSet() {
            const vm = this
            if (!vm.ids.length) {
                vm.$message.error('请选择需要公示的数据！')
                return false
            }
            vm.$confirm("请确认是否公示选中的数据？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                vm.isLoading = true
                const param = {ids: vm.ids}
                api.ExpendBatchSet(param).then(res => {
                    vm.isLoading = false
                    if (res.data.Code === 0) {
                        vm.$message({
                            message: "公示成功",
                            type: "success",
                        })
                        vm.loadData(1)
                    } else {
                        vm.$message({
                            message: res.data.Message,
                            type: "error",
                        });
                    }
                })
            })
        },
        batchDelete () {
            const vm = this
            if (!vm.ids.length) {
                vm.$message.error('请选择需要删除的数据！')
                return false
            }
            vm.$confirm("请确认是否删除选中的数据？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                vm.isLoading = true
                const param = {ids: vm.ids}
                api.DeleteExpend(param).then(res => {
                    vm.isLoading = false
                    if (res.data.Code === 0) {
                        vm.$message({
                            message: "删除成功",
                            type: "success",
                        })
                        vm.loadData(1)
                    } else {
                        vm.$message({
                            message: res.data.Message,
                            type: "error",
                        });
                    }
                })
            })
        },
        exportData() {
            const vm = this
            const param = Object.assign({}, vm.queryParam)
            vm.isExport = true
            api.ExportExpend(param).then(res => {
                vm.isExport = false
                if (res.data.Code === 0) {
                    saveAs(res.data.Data, '资金支出导出.xls')
                } else {
                    vm.$message({
                        type: "error",
                        message: `导出失败，详细原因：${res.Message}`,
                    });
                }
            })
        },
        downloadTemplate() {
            const url = process.env.VUE_APP_EXPEND_DONATION_TEMPLATE
            saveAs(url, '资金支出导入模板.xlsx')
        },
        onCheckFile(file, status) {
            const vm = this;
            let size = file.size / 1024 / 1024;
            vm.isLoading = true;
            if (size > 2) {
                this.$message({
                type: "error",
                message: "附件大小必须小于2M",
                });
                status(false);
                vm.isLoading = false;
                return;
            }
        },
        onFileUpLoad(res) {
            let vm = this;
            if (res.Code === 0) {
                vm.loadData(1);
                vm.$message({
                    type: "success",
                    message: "导入成功",
                });
            } else {
                vm.$message({
                    type: "error",
                    message: res.Message,
                });
            }
            vm.isLoading = false;
        },
        //选中事件
        onSelectionChange(rowData) {
            const vm = this
            vm.ids = []
            if (rowData.length) {
                rowData.forEach((item) => {
                    vm.ids.push(item.Id)
                })
            }
        },
        add() {
            const vm = this
            vm.$refs.editForm.create(null,1)
        },
        edit(row) {
            const vm = this
            vm.$refs.editForm.create(row,1)
        },
        innerDel(row) {
            const vm = this
            vm.$confirm("请确认是否删除选中的数据？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                vm.isLoading = true
                vm.ids = []
                vm.ids.push(row.Id)
                const param = {ids: vm.ids}
                api.DeleteExpend(param).then(res => {
                    vm.isLoading = false
                    if (res.data.Code === 0) {
                        vm.$message({
                            message: "删除成功",
                            type: "success",
                        })
                        vm.loadData(1)
                    } else {
                        vm.$message({
                            message: res.data.Message,
                            type: "error",
                        });
                    }
                })
            })
        },
        settingStatus(row) {
            const vm = this
            vm.$confirm(row.IsPublicity?"请确认是否取消公示选中的数据？":"请确认是否公示选中的数据？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                vm.isLoading = true
                const param = {Id: row.Id}
                api.ExpendSet(param).then(res => {
                    vm.isLoading = false
                    if (res.data.Code === 0) {
                        vm.$message({
                            message: "操作成功",
                            type: "success",
                        })
                        vm.loadData(1)
                    } else {
                        vm.$message({
                            message: res.data.Message,
                            type: "error",
                        });
                    }
                })
            })
        },
        loadData(item) {
            const vm = this
            vm.isLoading = true
            vm.queryParam.pageIndex = item
            const param = Object.assign({}, vm.queryParam)
            api.ExpendList(param).then(res => {
                vm.isLoading = false
                if (res.data.Code === 0) {
                    vm.total = res.data.Data.total
                    vm.list = res.data.Data.rows
                }
            })
        },
        reloadData() {
            const vm = this
            vm.loadData(1)
        },
        //改变分页大小
        handleSizeChange(val) {
            this.queryParam.pageSize = val;
            this.loadData(1);
        },
        //改变当前页码
        handleCurrentChange(val) {
            if (this.total > this.queryParam.pageSize) {
                this.loadData(val);
            }
        },
        //列表高度
        tableMaxHeight() {
            var clientHeight = window.innerHeight;
            var tableMaxHeight = 0;
            if (clientHeight && clientHeight !== undefined) {
                tableMaxHeight = clientHeight - 363;
            }
            return tableMaxHeight;
        },
        callBack() {
            const vm = this
            vm.loadData(1)
        }
    }
}
</script>
<style scoped lang="scss">
/deep/ .list .tool-bar{
    line-height: 0!important;
    padding: 10px 20px!important;
}
.upload-demo {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 30.6px;

  /deep/ .el-upload__input {
    display: none;
  }

  /deep/.el-upload-list {
    display: none;
  }
}
</style>